import { Box, Typography, useTheme } from '@mui/material';
import { EditIcon } from 'src/assets/icons/EditIcon';

type Props = {
  title: string;
  toggleEditHandler: (title: string | null) => void;
  iconSize?: number;
  greyColor: string;
};

export const TitleWithEditBox = ({ title, toggleEditHandler, iconSize, greyColor }: Props) => {
  const theme = useTheme();
  return (
    <Box sx={{ display: 'flex' }}>
      <Typography
        data-sm={title}
        sx={{
          color: theme.palette.text.primary,
          fontWeight: '700',
          fontSize: '24px',
          whiteSpace: 'nowrap',

          overflow: 'hidden',
          textOverflow: 'ellipsis',
          [theme.breakpoints.down('sm')]: {
            fontSize: '18px',
          },
        }}
      >
        {title}
      </Typography>
      <Box
        sx={{ cursor: 'pointer', marginTop: '5px', marginLeft: '12px' }}
        onClick={() => toggleEditHandler(null)}
        data-testid="edit-icon-box"
      >
        <EditIcon width={iconSize} height={iconSize} fill={greyColor} />
      </Box>
    </Box>
  );
};
